module.exports = __webpack_public_path__ + "04_medium_gray.8ba6a889.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_medium_gray.png
// module id = R6xr
// module chunks = 0